import React from "react";
import PropTypes from "prop-types";
import ProjectTile from "common/containers/project_tile";

const PostedProjects = ({ items, categories, user, industries }) => {
  return (
    <div>
      {items.map((item) => (
        <ProjectTile
          item={item}
          categories={categories}
          industries={industries}
          authenticated={!!user.id}
          userType={user.user_type || "Anonymous"}
          key={item.id}
        />
      ))}
    </div>
  );
};

PostedProjects.propTypes = {
  items: PropTypes.array.isRequired,
  industries: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
};

export default PostedProjects;
